export default {
  'reports.title': 'Reports',
  'reports.button.open': 'Open',
  'reports.builder.notPublished': 'This report is not published yet',
  'reports.builder.notPublished.description': 'Publish a version so users can open it.',
  'reports.builder.new.title': 'New report',
  'reports.builder.preview.empty': 'Your report starts here',
  'reports.builder.preview.empty.description':
    'Describe it in the chat and the assistant will build it step by step',
  'reports.builder.preview.empty.hint': 'Type in the chat to get started',
  'reports.builder.sidebar.overview': 'Overview',
  'reports.builder.section.accessControl': 'Access control',
  'reports.builder.chat': 'Assistant',
  'reports.builder.chat.title': 'AI Assistant',
  'reports.builder.chat.open': 'Open assistant',
  'reports.builder.chat.close': 'Close assistant',
  'reports.builder.code': 'Code',
  'reports.builder.code.empty': 'This draft has no code.js or code.css yet.',
  'reports.builder.code.emptyFile': 'This file has no content.',
  'reports.manageReports.title': 'Manage Reports',
  'reports.tab.groups': 'Groups',
  'reports.tab.favorites': 'Favorites',

  'reports.manageGroups.components.powerBIServerConfigurationId': 'Power BI Server Configuration',
  'reports.manageGroups.components.powerBIReportGroupId': 'PowerBI Report Group Id',
  'reports.manageGroups.components.powerBIReportId': 'PowerBI Report Id',
  'reports.manageGroups.components.menuTitle': 'Menu Title',
  'reports.manageGroups.components.menuTooltip': 'Menu Tooltip',
  'reports.manageGroups.components.textHelp': 'Menu Help Text',
  'reports.manageGroups.components.asLink': 'Show as Link',
  'reports.manageGroups.components.powerBIConnector': 'Power BI Connector',

  'reports.manageReports.components.report-group': 'Report Group',
  'reports.manageReports.components.tagLink': 'Report Classification Tags',
  'reports.manageReports.components.multiplePages': 'Multiple Pages?',
  'reports.manageReports.components.defaultReport': 'Default Report Section',
  'reports.manageReports.components.enableDataFilter': 'Enable Report Data Filter by User?',
  'reports.manageReports.components.reportFilter': 'Enable Report Data Filter by User?',

  'reports.manageReports.components.reportId': 'PowerBI Report Id',
  'reports.manageReports.components.datasetId': 'PowerBI Dataset Id',
  'reports.manageReports.components.defaultReportSection': 'Default Report Section',
  'reports.manageReports.components.isMultipage': 'Multiple Pages?',
  'reports.manageReports.components.isReportDataFilterByUserEnabled':
    'Enable Report Data Filter by User?',
  'reports.manageReports.components.isReportDataFilterByPositionEnabled':
    'Filter Report Data by Position?',
  'reports.platform': 'Platform',

  'reports.manageReports.components.reportDataFilterUserTableName': 'Table Name for User Filter',
  'reports.manageReports.components.reportDataFilterUserFieldName': 'Field Name for User Filter',
  'reports.manageReports.components.reportDataFilterUserFieldNameInternal':
    'Internal Field Name for User Filter',
  'reports.manageReports.components.reportDataFilterPositionTableName':
    'Table Name for Position Filter',
  'reports.manageReports.components.reportDataFilterPositionFieldName':
    'Field Name for Position Filter',
  'reports.manageReports.components.reportDataFilterPositionFieldNameInternal':
    'Internal Field Name for Position Filter',
  'reports.operador.or': 'Or',
  'reports.operador.and': 'And',
  'reports.permissionsFiltersLogicalOperator': 'Logical Operator for Permissions Filters',

  'reports.type.administration': 'Administration',
  'reports.type.process': 'Process',
  'reports.type.request': 'Request',
  'reports.type.generic': 'Generic',
  'reports.type.powerbiconnector': 'Power BI Connector',

  'reports.platform.web': 'Web',
  'reports.platform.mobile': 'Mobile',
  'reports.platform.webmobile': 'WebMobile',

  'reports.export.title': 'Export report',
  'reports.export.pdf': 'Export as PDF',
  'reports.export.pptx': 'Export as PowerPoint',
  'reports.export.requestSent':
    'Export request sent. You will receive a notification when it is ready.',
  'reports.export.generating': 'Generating...',
  'reports.export.inProgress': 'Generating',
  'reports.export.ready': 'File ready for download',
  'reports.export.error': 'Error generating file',
  'reports.export.failed': 'Error',
  'reports.fullscreen': 'Fullscreen',
  'reports.exitFullscreen': 'Exit fullscreen',
  'reports.detail.back': 'Back',
  'reports.detail.refresh': 'Refresh',
  'reports.detail.configure': 'Configure',
  'reports.detail.tagline.fallback': 'View and explore the embedded report.',
  'reports.detail.mobile.scrollHint':
    'Swipe in any direction to explore the report. Use fullscreen for a better view.',
  'reports.detail.mobile.gestureHint': 'Tap to use · Swipe to pan',
  'reports.detail.mobile.zoomIn': 'Zoom in',
  'reports.detail.mobile.zoomOut': 'Zoom out',
  'reports.detail.notFound': 'The report does not exist or was not found.',
  'reports.detail.loadError': 'The report could not be loaded.',
  'reports.detail.embedError': 'The Power BI report could not be embedded.',
  'reports.detail.pages': 'Report pages',
  'reports.detail.mobile.pages': 'Report pages',
  'reports.detail.tab.report': 'Report',
  'reports.detail.tab.datasets': 'Dataset',
  'reports.detail.tagline.datasets':
    'Health, sync and scope of the datasets that feed this report.',

  'reports.datasets.loading': 'Loading the dataset inventory…',
  'reports.datasets.filter.aria': 'Filter datasets',
  'reports.datasets.filter.all': 'All',
  'reports.datasets.filter.globals': 'Globals',
  'reports.datasets.filter.process': 'By process',
  'reports.datasets.filter.attention': 'Needs attention',
  'reports.datasets.section.globals': 'Global dimensions',
  'reports.datasets.section.process': 'Process data',
  'reports.datasets.section.unassigned': 'Unassigned',
  'reports.datasets.updated': 'updated {when}',
  'reports.datasets.processing': 'Syncing now',
  'reports.datasets.pending': 'Pending',
  'reports.datasets.health.healthy': 'Healthy',
  'reports.datasets.health.lagging': 'Lagging',
  'reports.datasets.health.reconciliationPending': 'Reconciliation pending',
  'reports.datasets.health.antiEntropyOverdue': 'Anti-entropy overdue',
  'reports.datasets.health.failed': 'Failed',
  'reports.datasets.health.rebuildRequired': 'Rebuild required',
  'reports.datasets.health.noStream': 'No stream',
  'reports.datasets.health.unknown': 'Status',
  'reports.datasets.state.synced': 'Synced',
  'reports.datasets.state.notSynced': 'Not synced',
  'reports.datasets.state.failed': 'Sync failed',
  'reports.datasets.error.timeout': 'Timed out',
  'reports.datasets.error.transientSql': 'Transient SQL error',
  'reports.datasets.error.transientStorage': 'Transient storage error',
  'reports.datasets.error.storageConflict': 'Storage conflict',
  'reports.datasets.error.permanent': 'Permanent error',
  'reports.datasets.error.default': 'Sync error',
  'reports.datasets.error.load': 'The dataset inventory could not be loaded.',
  'reports.datasets.error.forbidden': 'You do not have permission to view the dataset inventory.',
  'reports.datasets.error.powerbi': 'Dataset inventory is only available for Native reports.',
  'reports.datasets.status.aria': 'Operational snapshot',
  'reports.datasets.status.due': '{count} due',
  'reports.datasets.status.failed': '{count} failed',
  'reports.datasets.version.published': 'Published version {version}',
  'reports.datasets.version.draft': 'Version {version} · draft',
  'reports.datasets.field.stream': 'Stream',
  'reports.datasets.field.schema': 'Schema',
  'reports.datasets.field.interval': 'Interval',
  'reports.datasets.field.intervalValue': '{seconds} seconds',
  'reports.datasets.field.lastData': 'Last data',
  'reports.datasets.field.lastSync': 'Last sync',
  'reports.datasets.field.lastRebuild': 'Last rebuild',
  'reports.datasets.field.lastReconcile': 'Last reconciliation',
  'reports.datasets.field.node': 'Node',
  'reports.datasets.field.process': 'Process',
  'reports.datasets.empty.company': 'No synced datasets yet',
  'reports.datasets.empty.companyHint':
    'When this environment has active sync rows — global dimensions or process facts — they will appear here with health and sync state.',
  'reports.datasets.empty.report': 'This report has no datasets yet',
  'reports.datasets.empty.reportHint':
    'Logical datasets from the draft or published version are listed here, even when they are not materialized yet.',
  'reports.datasets.empty.search': 'Nothing matches your search',
  'reports.datasets.empty.searchHint': 'Try the dataset name, key or process.',
  'reports.datasets.files.title': 'Published files',
  'reports.datasets.files.generation': 'Generation {generation}',
  'reports.datasets.files.empty': 'There is no published generation yet.',
  'reports.datasets.files.notSynced': 'Not synced yet. There are no lake files.',
  'reports.datasets.files.missing': 'This dataset stream was not found.',
  'reports.datasets.files.error': 'The published file list could not be loaded.',
  'reports.datasets.files.kind.parquet': 'Parquet',
  'reports.datasets.files.kind.manifest': 'Manifest',
  'reports.datasets.files.download': 'Download',
  'reports.datasets.files.downloadError': 'The file could not be downloaded.',
  'reports.datasets.files.preview': 'View sample',
  'reports.datasets.files.previewFile': 'View file',
  'reports.datasets.files.previewError': 'The file could not be opened.',
};
